// import Vue from 'vue'

export default {
    Rockslide: 'rockslides',
    Landslide: 'landslide',
    Flood: 'flood',
    Avalance: 'avalanches',
    // MET
    Ice: 'ice',
    RainFlood: 'rainFlood',
    ForestFire: 'forestFire',
    PolarLow: 'polarLow',
    BlowingSnow: 'blowingSnow',
    Lightning: 'lightning',

    getInfoText(hazardTypeId) {
        switch (hazardTypeId) {
            case "Lightning":
            case "lightning":
            case "Mye lyn":
                return " Farevarsel om mye lyn og tordenaktivitet som kan gi lokalt kraftige vindkast og regnbyger, samt fare for skade på objekt(er) som følge av lynnedslag, eventuelt hagl."
            case "Flom":
            case "flood":
                return "Flomvarslene gir en regional oversikt over områder og vassdrag med fare for flom. Varslene er basert på en firetrinns aktsomhetskala";
            case "Jordskred":
            case "landslide":
                return (
                    "Jordskredvarslene gir en regional oversikt over områder med fare for jordskred, sørpeskred og/eller flomskred. " +
                    "Varslene er basert på en firetrinns aktsomhetsnivåskala. Jordskred: Utglidninger og rask bevegelse av vannmettet jord i bratte skråninger. " +
                    "Flomskred: En flom av vann, jord og stein i bratte bekkeløp. Vann på avveie i bratt terreng som kan medføre bekkeløpsendring." +
                    "Sørpeskred: En strøm av vannmettet snø som kan utløses i slakt terreng og deretter følge bekkeløp og bratte skråninger."
                );
            case "Snøskred":
            case "avalanches":
                return (
                    "Snøskredvarslene gjelder for store områder, og gir informasjon om den generelle snøkredfaresituasjonen i en varslingsregion. " +
                    "Varslene er basert på den femtrinns europeiske faregradsskalaen"
                );
            case "Regn":
            case "rain":
                return "Farevarsel om regn, med potensiale for overvann i tettbebygde områder og på veier";
            case "Styrtregn":
            case "Kraftige regnbyger":
            case "rainFlood":
                return (
                    "Farevarsel om kraftige lokale regnbyger med kort varighet (styrtregn), med konsekvenser for overvann i tettbygde områder og på veier, lokale oversvømmelser, " +
                    "bekke- og elveløpsendringer, jord- og flomskred, lyn og torden der regnbygene treffer."
                );
            case "Is":
            case "ice":
            case "Is på vei":
            case "Is (på vei og andre objekter)":
                return (
                    "Farevarselet for is sendes der årsaken er underkjølt regn/yr, frysende regn eller frosttåke. I de tre tilfellene vil vi kunne få et islag på vei og andre " +
                    "objekter, noe som blant annet kan være svært farlig særlig i trafikken."
                );
            case "Frysende regn":
            case "freezingRain":
                return "Farevarselet for frysende regn sendes der årsaken er underkjølt regn/yr, frysende regn eller frosttåke. I de tre tilfellene vil vi kunne få et islag på vei og " +
                    "andre objekter, noe som blant annet kan være svært farlig særlig i trafikken."
            case "Ising på fartøy":
            case "ising":
            case "icing":
                return "Fare for moderat ising på skip i utsatte kyst- og fjordstrøk i forbindelse med lav temperaur og sjøsprøyt";
            case "Snøfokk":
            case "blowingSnow":
                return "Farevarselet for snøfokk blir sendt om det er ventet snøvær og vind, eller oppholdsvær med vind når løs snø er tilgjengelig. Farevarselet blir kun varslet på gult nivå. " +
                    "Det blir ikke sendt snøfokkfarevarsel i et område som allerede har farevarsel for snø, vindkast eller polart lavtrykk, ettersom snøfokk da er en naturlig konsekvens. Kjennetegn " +
                    "på snøfokk er siktreduksjon, kuling eller sterkere vind og minusgrader med tørr løs snø.";
            case "Snø":
            case "snow":
                return "Farevarsel om snø, med konsekvenser for infrastruktur og samferdsel";
            case "Vindkast":
            case "wind":
                return "Farevarsel om sterk vind over land basert på vindkast, med konsekvenser for samferdsel, infrastruktur og løse gjenstander";
            case "Skogbrann":
            case "forestFire":
                return "Varsel om skogbrann";
            case "Vannstand langs kysten og i fjordene":
            case "stormSurge":
                return "Farevarsel om høy vannstand langs kysten og i fjordene, med konsekvenser for infrastruktur og bygninger i strandsonen";
            case "Polart lavtrykk":
            case "polarLow":
                return "Varsel om fare for intense lavtrykk med tett snøfall og mye vind, ofte med usikker plassering";
            case "rockslides":
                return "Fjellskredvarslene gir en regional oversikt over områder med fare for fjellskred. Varslene er basert på en firetrinns aktsomhetskala";
            default:
                return hazardTypeId;
        }
    },

}